const BASE = process.env.REACT_APP_SERVICE_ENDPOINT_NE;

// GET /api/gafetes/ListaUsuarios
export const getUsuarios = async (token) => {
    const res = await fetch(`${BASE}/gafetes/ListaUsuarios`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error('Error al obtener usuarios');
    return res.json();
};

// POST /api/gafetes/AsignarTarjeta — larga duración (hasta ~32s servidor)
// Devuelve { status, message } para que el modal maneje cada código
export const asignarTarjeta = async (celda, idUsuario, token, signal) => {
    const res = await fetch(`${BASE}/gafetes/AsignarTarjeta`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ celda, idUsuario }),
        signal,
    });
    const message = await res.text();
    return { status: res.status, message };
};

// POST /api/gafetes/DesasignarTarjeta?id={userId}
export const desasignarTarjeta = async (userId, token) => {
    const res = await fetch(`${BASE}/gafetes/DesasignarTarjeta?id=${userId}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error('Error al desasignar tarjeta');
};
